<template>
  <div>
    <h3 style="color: #a1a1a1;" class="mb-0">N/A</h3>
    <p style="color: #a1a1a1;">No data available for {{ sectionTitle }} yet.</p>
  </div>
</template>

<script>
export default {
    props: ["sectionTitle"]
};
</script>
